import * as zod from 'zod';

import { DeviceCommand } from '@sb/integrations/types';

export const ZeroForceTorqueSensorArguments = zod.object({
  // The device command that zeroes the sensor (e.g. an OnRobotHexE "zero"
  // command). Built by the step wizard's `toRoutineRunner` from the selected
  // sensor so the runner stays brand-agnostic.
  command: DeviceCommand,
  // The equipment ID of the sensor the operator selected. Used to verify the
  // enabled sensor still matches the selection at play time.
  deviceID: zod.string().optional(),
});

export type ZeroForceTorqueSensorArguments = zod.infer<
  typeof ZeroForceTorqueSensorArguments
>;
